<template>
  <v-toolbar :src="toolbarBackground" class="toolbar" dark extended>
    <v-row justify="space-between">
        <v-col cols="3" class="mt-5">
            <v-toolbar-title>
            <router-link to="/">
                <v-img
                class=" main-logo"
                contain
                src="/assets/logo-zielone.png"
                height="88px"
                width="200px"
                ></v-img>
            </router-link>
            </v-toolbar-title>
        </v-col>
        <v-col cols="9" class="mt-8">
            <v-toolbar-items >
                    <navigation-item
                        v-for="(item, index) in items"
                        v-if="item.show"
                        :key="index"
                        :icon="item.icon"
                        :label="item.label"
                        :route="item.route"
                        :text="item.text"
                    />
                    <navigation-item v-if="$auth.check()" :label="$t('nav.logout')">
                        <template v-slot="{ on }">
                        <v-btn v-on="on" @click="logout" class="mt-4" text>
                            <v-icon>mdi-logout</v-icon>
                        </v-btn>
                        </template>
                    </navigation-item>

            </v-toolbar-items>
        </v-col>

    </v-row>
    <template v-slot:extension>
      <v-speed-dial
        bottom
        class="language-select-dial"
        direction="right"
        transition="slide-x-transition"
        left
        v-model="langDial"
      >
        <template v-slot:activator>
          <v-btn color="blue-grey lighten-4" dark fab small>
            <v-icon v-if="!langDial">$vuetify.icons.{{ $i18n.locale }}</v-icon>
            <v-icon v-else>mdi-translate</v-icon>
          </v-btn>
        </template>
        <v-btn
          @click="setLocale('pl')"
          color="blue-grey lighten-5"
          dark
          fab
          x-small
        >
          <v-icon>$vuetify.icons.pl</v-icon>
        </v-btn>
        <v-btn
          @click="setLocale('en')"
          color="blue-grey lighten-5"
          dark
          fab
          x-small
        >
          <v-icon>$vuetify.icons.en</v-icon>
        </v-btn>
      </v-speed-dial>
    </template>
  </v-toolbar>
</template>

<script>
import i18n from "@/plugins/vuei18n";
import axios from "axios";
import NavigationItem from "./Item";

export default {
  name: "Navigation.vue",
  components: { NavigationItem },
  computed: {
    items() {
      return [
        {
          icon: "mdi-floor-plan",
          label: this.$t("nav.configurator-terrace"),
          route: "Configurator",
          show: this.$auth.check(),
          text: this.$t("nav.configurator-terrace"),
        },
        {
          icon: "mdi-floor-plan",
          label: this.$t("nav.configurator-elevation"),
          route: "Elevation",
          show: this.$auth.check(),
          text: this.$t("nav.configurator-elevation"),
        },
        {
          icon: "mdi-ballot",
          label: this.$t("nav.manual_order"),
          route: "ManualOrder",
          show: this.$auth.check(),
          text: this.$t("nav.manual_order"),
        },
        {
          icon: "mdi-offer",
          label: this.$t("nav.offers"),
          route: "Offers",
          show: this.$auth.check(),
          text: this.$t("nav.offers"),
        },
        {
          icon: "mdi-shopping-search",
          label: this.$t("nav.orders"),
          route: "Orders",
          show: this.$auth.check(),
          text: this.$t("nav.orders"),
        },
        {
          icon: "mdi-cube-send",
          label: this.$t("nav.sent"),
          route: "Sent",
          show: this.$auth.check(),
          text: this.$t("nav.sent"),
        },
        {
          icon: "mdi-warehouse",
          label: this.$t("nav.materials"),
          route: "Materials",
          show: this.$auth.check("admin"),
          text: this.$t("nav.materials"),
        },
        {
          icon: "mdi-table-large-plus",
          label: this.$t("nav.complementary_materials"),
          route: "ComplementaryMaterials",
          show: this.$auth.check("admin"),
          text: this.$t("nav.complementary_materials"),
        },
        {
          icon: "mdi-table-large-plus",
          label: this.$t("nav.marketing_materials"),
          route: "MarketingMaterials",
          show: this.$auth.check(),
          text: this.$t("nav.marketing_materials"),
        },

        {
          icon: "mdi-account-multiple",
          label: this.$t("nav.users"),
          route: "Users",
          show: this.$auth.check("admin"),
          text: this.$t("nav.users"),
        },
        {
          icon: "mdi-wrench",
          label: this.$t("nav.settings"),
          route: "Settings",
          show: this.$auth.check("admin") || this.$auth.check("partner"),
          text: this.$t("nav.settings"),
        },
        {
          icon: "mdi-login",
          label: this.$t("nav.login"),
          route: "Login",
          show: !this.$auth.check(),
          text: '',
        },
      ];
    },
  },
  data() {
    return {
      toolbarBackground: "/assets/kalkulator-tlo.jpg",
      langDial: false,
    };
  },
  methods: {
    logout() {
      this.$auth.logout();
      this.$router.push({ name: "Login" });
    },
    setLocale(locale) {
      this.$cookies.set("locale", locale);
      i18n.locale = locale;
      axios.defaults.baseURL = window.location.origin + "/api/" + locale;
      this.$router.go();
    },
  },
};
</script>

<style>
.main-logo  {
  top: 10px;
}

.toolbar {
  position: relative;
}

.toolbar .v-toolbar__image {
  filter: brightness(82%);
}

.navbar-icon {
  display: block;
}

.navbar-text {
  display: block;
}

.language-select-dial {
  bottom: -22px;
}
</style>
